import { jsx, jsxs, Fragment } from '@emotion/react/jsx-runtime';
import Icon from '../components/Icon/Icon.js';

const IconChat = ({
  title,
  titleId,
  filled = void 0,
  ...props
}) => /* @__PURE__ */ jsx(Icon, { ...props, children: /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId,
    "aria-hidden": !title,
    role: title ? "img" : void 0,
    width: "1em",
    height: "1em",
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      filled ? /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx("path", { d: "M6 3h30a3.01 3.01 0 012.995 2.824L39 6v3h3a3.01 3.01 0 012.995 2.824L45 12v21a3.01 3.01 0 01-2.824 2.995L42 36h-3v7.5a1.5 1.5 0 01-2.448 1.162l-.112-.101L27.879 36h-15.88a3.01 3.01 0 01-2.994-2.824L9 33v-3H6a3.01 3.01 0 01-2.995-2.824L3 27V6a3.01 3.01 0 012.824-2.995L6 3h30H6zm30 3H6v21h3V12a3.01 3.01 0 012.824-2.995L12 9h24V6z" }) }) : /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx("path", { d: "M6 3h30a3.01 3.01 0 012.995 2.824L39 6v3h3a3.01 3.01 0 012.995 2.824L45 12v21a3.01 3.01 0 01-2.824 2.995L42 36h-3v7.5a1.5 1.5 0 01-2.448 1.162l-.112-.101L27.879 36h-15.88a3.01 3.01 0 01-2.994-2.824L9 33v-3H6a3.01 3.01 0 01-2.995-2.824L3 27V6a3.01 3.01 0 012.824-2.995L6 3h30H6zm36 9H12v21h17.109l6.89 6.879V33h6V12zm-6-6H6v21h3V12a3.01 3.01 0 012.824-2.995L12 9h24V6z" }) })
    ]
  }
) });

export { IconChat as default };
